import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import rootReducer from "./reducers";
import { baseApi } from "./services"; // Import the baseApi

// Combine the existing rootReducer with the baseApi reducer
const combinedReducer = combineReducers({
  ...rootReducer, // Spread existing reducers
  [baseApi.reducerPath]: baseApi.reducer, // Add baseApi reducer
});

// Configure the store
const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware), // Add the baseApi middleware
});

// Persistor
export const persistor = persistStore(store);

// Setup listeners (optional)
setupListeners(store.dispatch);

export default store;
